export default "__VITE_ASSET__CaJLIpyk__"